import httpManager from "@/app/shared/utils/httpManager";

/**
 *
 * @param {Number} chatbotId
 * @returns {Promise<Object>} Chatbot details
 */

export async function fetchChatbotDetails(chatbotId) {
  const url = `/chatbots/${chatbotId}/`;
  const response = await httpManager.get(url);
  return response.data;
}
